export const ProjectsActionTypes = {
  GetProjects: 'PROJECTS_GET_PROJECTS',
  GetProjectSuccess: 'PROJECTS_GET_PROJECTS_SUCCESS',
  GetProjectError: 'PROJECTS_GET_PROJECTS_ERROR',
  SetPagination: 'PROJECTS_SET_PAGINATION',
  ExportListToFile: 'EXPORT_LIST_TO_FILE',
  ExportListToFileSuccess: 'EXPORT_LIST_TO_FILE_SUCCESS',
  ExportListToFileError: 'EXPORT_LIST_TO_FILE_ERROR',
  ChangeDueDateJob: 'PROJECTS_CHANGE_DUE_DATE_JOB',
  ChangeDueDateJobSuccess: 'PROJECTS_CHANGE_DUE_DATE_JOB_SUCCESS',
  ChangeDueDateJobError: 'PROJECTS_CHANGE_DUE_DATE_JOB_ERROR',
  ChangeDueDateProject: 'PROJECTS_CHANGE_DUE_DATE_PROJECT',
  ChangeDueDateProjectSuccess: 'PROJECTS_CHANGE_DUE_DATE_PROJECT_SUCCESS',
  ChangeDueDateProjectError: 'PROJECTS_CHANGE_DUE_DATE_PROJECT_ERROR',
  ModifyLanguages: 'PROJECTS_MODIFY_LANGUAGES',
  ModifyLanguagesError: 'PROJECTS_MODIFY_LANGUAGES_ERROR',
  ModifyLanguagesSuccess: 'PROJECTS_MODIFY_LANGUAGES_SUCCESS',
  ContentChanged: 'PROJECTS_CONTENT_CHANGED',
  ContentChangedError: 'PROJECTS_CONTENT_CHANGED_ERROR',
  ContentChangedSuccess: 'PROJECTS_CONTENT_CHANGED_SUCCESS',
  ContentChangedUpdate: 'PROJECTS_CONTENT_CHANGED_UPDATE',
  ContentChangedSend: 'PROJECTS_CONTENT_CHANGED_SEND',
  ContentChangedIgnore: 'PROJECTS_CONTENT_CHANGED_IGNORE',
  ContentRemovedRemove: 'PROJECTS_CONTENT_REMOVED_REMOVE',
  ContentRemovedRemoveError: 'PROJECTS_CONTENT_REMOVE_REMOVED_ERROR',
  ContentRemovedRemoveSuccess: 'PROJECTS_CONTENT_REMOVE_REMOVED_SUCCESS',
  ContentRemovedIgnore: 'PROJECTS_CONTENT_REMOVED_IGNORE',
  ContentRemovedIgnoreError: 'PROJECTS_CONTENT_REMOVED_IGNORE_ERROR',
  ContentRemovedIgnoreSuccess: 'PROJECTS_CONTENT_REMOVED_IGNORE_SUCCESS',
  ErrorMessageIgnore: 'PROJECTS_ERROR_MESSAGE_IGNORE',
  ErrorMessageIgnoreError: 'PROJECTS_ERROR_MESSAGE_IGNORE_ERROR',
  ErrorMessageIgnoreSuccess: 'PROJECTS_ERROR_MESSAGE_IGNORE_SUCCESS',
  CheckProject: 'PROJECTS_CHECK_PROJECT',
  CheckProjectSuccess: 'PROJECTS_CHECK_PROJECT_SUCESS',
  CheckProjectClear: 'PROJECTS_CHECK_PROJECT_CLEAR',
  GetProjectLanguages: 'PROJECT_GET_PROJECT_LANGUAGES',
  GetProjectLanguagesError: 'PROJECT_GET_PROJECT_LANGUAGES_ERROR',
  GetProjectLanguagesSuccess: 'PROJECT_GET_PROJECT_LANGUAGES_SUCCESS',
  GetProjectWorkflowSteps: 'PROJECT_GET_PROJECT_WORKFLOW_STEPS',
  GetProjectWorkflowStepsError: 'PROJECT_GET_PROJECT_WORKFLOW_STEPS_ERROR',
  GetProjectWorkflowStepsSuccess: 'PROJECT_GET_PROJECT_WORKFLOW_STEPS_SUCCESS',
  CheckErrorProject: 'PROJECTS_CHECK_ERROR_PROJECT',
  CheckErrorProjectSuccess: 'PROJECTS_CHECK_ERROR_PROJECT_SUCESS',
  CheckErrorProjectClear: 'PROJECTS_CHECK_ERROR_PROJECT_CLEAR',
  GetProjectChangedContent: 'PROJECT_GET_PROJECT_CHANGED_CONTENT',
  GetProjectChangedContentError: 'PROJECT_GET_PROJECT_CHANGED_CONTENT_ERROR',
  GetProjectChangedContentSuccess: 'PROJECT_GET_PROJECT_CHANGED_CONTENT_SUCCESS',
  GetXTMRequestersForProject: 'PROJECT_GET_XTM_REQUESTER_FOR_PROJECT',
  GetXTMRequestersForProjectError: 'PROJECT_GET_XTM_REQUESTER_FOR_PROJECT_ERROR',
  GetXTMRequestersForProjectSuccess: 'PROJECT_GET_XTM_REQUESTER_FOR_PROJECT_SUCCESS',
  GetXTMCustomersForUser: 'PROJECT_GET_XTM_CUSTOMER_FOR_USER',
  GetXTMCustomersForUserError: 'PROJECT_GET_XTM_CUSTOMER_FOR_USER_ERROR',
  GetXTMCustomersForUserSuccess: 'PROJECT_GET_XTM_CUSTOMER_FOR_USER_SUCCESS',
  SetProjectSearch: 'PROJECT_SET_PROJECT_SEARCH',
};
